import { Route, Routes } from 'react-router-dom'

import ActivationPlanPage from '@/features/activationPlan/pages/ActivationPlanPage'
import NavigateToError from '@/features/error/pages/NavigateToError'

export default function ActivationPlanRoutes() {
  return (
    <Routes>
      <Route index element={<ActivationPlanPage />} path="/" />
      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </Routes>
  )
}
